/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from '../ui/Button';

interface CTAProps {
    onGetStarted: () => void;
}

export const CTA: React.FC<CTAProps> = ({ onGetStarted }) => {
  return (
    <section className="py-32 bg-[#0A0B0F] text-white relative overflow-hidden">
       {/* Background Elements */}
       <div className="absolute inset-0 pointer-events-none">
           <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white/5 via-[#0A0B0F] to-[#0A0B0F]"></div>
       </div>

       <div className="container mx-auto px-6 text-center relative z-10">
           <h2 className="font-serif text-5xl md:text-7xl mb-6 tracking-tight">
               Ready to go <span className="italic text-gray-500">Ghost?</span>
           </h2>
           <p className="text-xl text-gray-400 mb-12 max-w-2xl mx-auto leading-relaxed">
               Join the fastest growing privacy-preserving commerce network today. <br/>
               No credit card required. No unnecessary KYC.
           </p>
           <div className="flex flex-col sm:flex-row justify-center gap-4">
               <Button onClick={onGetStarted} variant="primary" size="lg" className="bg-white !text-black hover:bg-gray-200 shadow-[0_0_20px_rgba(255,255,255,0.1)] px-8 h-14 text-base font-bold">
                   Start Transacting <ArrowRight size={20} className="ml-2"/>
               </Button>
               <Button onClick={onGetStarted} variant="outline" size="lg" className="border-white/20 text-white hover:bg-white/10 px-8 h-14 text-base">
                   Talk to Sales
               </Button>
           </div>
           <p className="mt-8 text-xs text-gray-600 font-mono uppercase tracking-widest">
               Trusted by 10,000+ Sovereign Merchants
           </p>
       </div>
    </section>
  );
};
